import { Component, OnInit, Input, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { AuthService } from 'src/app/core/authentication/auth.service';
import { CommunicationService } from 'src/app/shared/services/communication/communication.service';
import { Company } from 'src/app/shared/interfaces/company';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Modalconfig, ProfileTypes, identityUrl } from 'src/app/shared/constants';
import { Subscription } from 'rxjs';
import { SessionStorageService } from 'src/app/shared/services/session-storage/session-storage.service';
import { find } from 'lodash';
import { CommonHttpService } from 'src/app/shared/services/common-http/common-http.service';
import { CompanySettingComponent } from 'src/app/shared/components/company-setting/company-setting.component';
import { Router } from '@angular/router';
import { UserGuidePreviewComponent } from 'src/app/shared/components/user-guide-preview/user-guide-preview.component';
import { LoginAsLogOffAsModel } from 'src/app/shared/model/common.models';
import { ProfileDetail } from 'src/app/profile/shared/models/profile-setting.models';
import { sessionProfile, profileRoles } from 'src/app/shared/interfaces/sessionStorageModel';
@Component({
    selector: 'app-top-bar',
    templateUrl: './top-bar.component.html',
    styleUrls: ['./top-bar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TopBarComponent implements OnInit, OnDestroy {

  sideBarshow = false;
  bsModalRef: BsModalRef;
  companyDetail: Company;
  companyId: number;
  // Set selected modules variables
  activeModule = '';
  isTranslationModule = false;
  subscription: Subscription;
  companyIdSubscription: Subscription;
  loggedInUserRole: string;
  loggedInUserType: number;
  isDisplayCompanyLogo: boolean;
  isDisplayCompanyIcon: boolean;
  isAltDisplayCompanyLogo: boolean;
  isAltDisplayCompanyIcon: boolean;
  isLogOffUser: boolean;
  checkCompanyId: number;
  logOffUserName: string;
  isMenuCollapsed = false;
  isMobileView: boolean;
  loggedInProfile: sessionProfile;
  profileAssetId: number;
  disableSettingsBtn = false;
  constructor(
    private cdr: ChangeDetectorRef,
    private authService: AuthService,
    private communicationService: CommunicationService,
    private commonHttpService: CommonHttpService,
    private modalServices: BsModalService,
    private sessionStorageService: SessionStorageService,
    private router: Router
  ) {
  }

  @Output() menuCollapsedStatus = new EventEmitter<boolean>();
  // Get the input value of the selected module from the app.component.ts.
  // According to that we will select that module.
  @Input()
  public set selectedModule(selectedModule: string) {
    this.activeModule = selectedModule;
    this.isTranslationModule = this.activeModule === 'PlaybookTranslation';
  }

  @Input() isBothNavigation: boolean;

  // Get companyId and Company information to show the company logo.
  getCompany() {
    this.subscription = this.communicationService.getCompany().subscribe(company => {
      this.checkCompanyId = company ? company.id : null;
      this.assignCompanyValue(company);
    });
    this.companyIdSubscription = this.communicationService.getCompanyId().subscribe(companyId => {
      if (!this.companyDetail && companyId) {
        const companyData = this.sessionStorageService.getCompanyData();
        this.checkCompanyId = companyData ? companyData.id : null;
        this.assignCompanyValue(companyData);
      }
    });
  }
  assignCompanyValue(company) {
    this.companyDetail = company;
    this.companyId = this.companyDetail ? this.companyDetail.id : null;
    this.isDisplayCompanyLogo = (this.companyDetail !== undefined
      && this.companyDetail !== null
      && this.companyDetail.assetId !== undefined
      && this.companyDetail.assetId != null
      && this.companyDetail.assetId > 0
      && this.checkCompanyId != null);
    this.isDisplayCompanyIcon = (this.companyDetail
      && this.companyDetail.iconAssetId
      && this.checkCompanyId != null);
    this.isAltDisplayCompanyLogo = (this.companyDetail
      && this.companyDetail.altCompanyLogoAssetId
      && this.checkCompanyId != null);
    this.isAltDisplayCompanyIcon = (this.companyDetail
      && this.companyDetail.altCompanyIconAssetId
      && this.checkCompanyId != null);
    this.cdr.detectChanges();
  }

  getUserClaims() {
    const profileData = this.sessionStorageService.getLoggedInProfileDetail();
    if (profileData) {
      this.loggedInUserRole = profileData.role;
      this.loggedInUserType = ProfileTypes[profileData.role];
      this.isLogOffUser = !!profileData.vPlaybookImpersonatedAuthCode;
      this.logOffUserName = profileData.vPlaybookFirstName + ' ' + profileData.vPlaybookLastName;
    }
  }

  redirectClearCompanyData(event, ...args) {
    event.preventDefault();
    this.router.navigate(args).finally(() => {
      if (args[0] === "profile" && args[1] === "settings" && this.checkUserRole()) {
        return;
      } else {
        this.communicationService.clearCompany();
      }
    });
  }

  checkUserRole() {
    return [profileRoles.administrator.toString(), profileRoles.playbookOwner.toString(), profileRoles.salesManager.toString(),
      profileRoles.user.toString()].indexOf(this.loggedInUserRole) !== -1;
  }

  ngOnInit() {
    this.companyDetail = new Company();
    this.getCompany();
    this.getUserClaims();
    this.isMobileView = window.innerWidth <= 767 ? true : false;
    this.loggedInProfile = this.sessionStorageService.getLoggedInProfileDetail();
    this.setProfileValues();
    this.fetchProfileAssetId();
  }

  signOut() {
    this.authService.signout();
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  // Check if top menu item can be showed by a user role.
  showNavigationItem(roles: string[]) {
    //  Todo: Remove first condition. Check for top bar not showing for Conversation Templates,Report Description
    // and Team assessments after reload.
    if (!this.loggedInUserRole) {
      this.getUserClaims();
    }
    if (this.loggedInUserRole) {
      const findUserRole = find(roles, (role) => {
        return role.toLowerCase() === this.loggedInUserRole.toLowerCase();
      });
      return findUserRole ? true : false;
    }
  }

  openEditCompnay() {
    if (this.companyId) {
      this.disableSettingsBtn = true;
      this.commonHttpService.get<Company>(
        {
          uri: '/api/Companies/' + this.companyId
        }).subscribe(response => {
          const company = response;
          this.disableSettingsBtn = false;
          if (company.isDeleted) {
            this.router.navigate([]);
          } else {
            const initialState = {
              company,
              verb: 'Edit',
              isDeleteShown: false
            };
            this.bsModalRef = this.modalServices.show(CompanySettingComponent,
              Object.assign({ initialState }, { class: 'custom-modal' }, Modalconfig));
          }
        });
    }
  }

  /**
   * To open the user guide modal
   */
  openUserGuideModal() {
    const initialState = {
      userType: this.loggedInUserType
    };
    this.bsModalRef = this.modalServices.show(UserGuidePreviewComponent,
      Object.assign({ initialState }, { class: 'custom-modal' }, Modalconfig));
  }

  logOffUser() {
    this.commonHttpService.post<null, LoginAsLogOffAsModel>({
      uri: `/api/Profiles/LogOffAsProfile`,
      message: {
        showMessage: true,
        successMessage: 'Successfully logged off.',
        errorMessage: 'something went wrong. Please try again.'
      }
    }).subscribe((response: LoginAsLogOffAsModel) => {
      this.sessionStorageService.clearSessionStorage();
      if (response.logOffCode) {
        window.location.href = `${identityUrl}/account/LogOffAsProfile?LogOffCode=${response.logOffCode}`;
      }
    });
  }

  openPlaybookPage() {
    const url = window.location.href.split('/');
    this.router.navigate(['/playbook/' + url[url.length - 1]]);
  }
  toggleMenuBar() {
    this.isMenuCollapsed = !this.isMenuCollapsed;
    this.menuCollapsedStatus.emit(this.isMenuCollapsed);
  }

  /**
   * Fetching the profile details and setting them for the logged in user
   * Setting the details to initial fetched values in case the user cancels edited changes
   */
  setProfileValues() {
    this.commonHttpService.get<ProfileDetail>(
      {
        uri: '/api/Profiles/GetProfileDeatilsForSetting?profileId=' + this.loggedInProfile.id,
      }).subscribe((response) => {
        this.profileAssetId = response.profileAssetId;
        this.cdr.detectChanges();
        sessionStorage.setItem('profileAssetId', JSON.stringify(this.profileAssetId));
      });
  }

  fetchProfileAssetId() {
    // setProfileValues
    this.communicationService.getShowProfileAssetId().subscribe((assetId) => {
      if (assetId) {
        this.profileAssetId = assetId !== -1 ? assetId : null;
        this.cdr.detectChanges();
      }
    });
  }
}
